import { isEmpty } from "lodash";
import { Base } from "../base";
import { Network, SUPPORTED_NETWORKS, toMainnet } from "../network";
import { NFTStandard, normalizeAddress } from "./nft";

export enum ContractError {
  MISSING_PROVIDER = "missing_provider",
  UNKNOWN_METHOD = "unknown_method",
  UNKNOWN_CONTRACT = "unknown_contract",
  UNKNOWN_FACTORY = "unknown_factory",
  UNAUTHORIZED = "unauthorized",
  UNSUPPORTED_NETWORK = "unsupported_network",
  EXECUTION_ERROR = "execution_error",
  EXECUTION_TIMEOUT = "execution_timeout",
}

export interface SmartContractParam extends Partial<SmartContract> {}

export class SmartContract extends Base {
  name: string;
  symbol: string;
  abi: any[];
  address?: string;
  network: Network;
  standard: NFTStandard;
  ipfsOnly: boolean;
  royaltyReceiver: string;
  royaltyFee: number;
  logo: string;
  description: string;
  factory?: ContractFactoryName;

  constructor(params?: SmartContractParam) {
    super(params);
    this.name = params?.name || "";
    this.symbol = params?.symbol || "";
    this.abi = params?.abi || [];
    this.network = toMainnet(params?.network || Network.AVALANCHE);
    this.standard = params?.standard || NFTStandard.ERC721;
    if (params?.address)
      this.address = normalizeAddress(this.network, params.address);
    this.ipfsOnly = !!params?.ipfsOnly;
    this.royaltyReceiver = params?.royaltyReceiver
      ? normalizeAddress(this.network, params?.royaltyReceiver)
      : "";
    this.royaltyFee = params?.royaltyFee ?? 0;
    this.logo = params?.logo || "";
    this.description = params?.description || "";
    if (params?.factory) this.factory = params.factory;
  }
}

export enum ContractFactoryName {
  ERC721_AIRDROP = "erc721-airdrop",
  ERC721_SOULBOUND_AIRDROP = "erc721-soulbound-airdrop",
  ERC1155_AIRDROP = "erc1155-airdrop",
}

export interface SmartContractParamFactory extends SmartContractFactory {
  name: ContractFactoryName;
}
export class SmartContractFactory extends Base {
  name: ContractFactoryName;
  contracts: { network: Network; address: string }[];
  abi: any[];
  templateAbi: any[];
  standard: NFTStandard;

  constructor(params: SmartContractParamFactory) {
    super(params);
    this.name = params.name;
    this.contracts =
      params.contracts && !isEmpty(params.contracts)
        ? params.contracts
            .filter((c) => SUPPORTED_NETWORKS.includes(c.network))
            .map((c) => ({
              network: toMainnet(c.network),
              address: normalizeAddress(c.network, c.address),
            }))
        : [];
    this.abi = params.abi || [];
    this.templateAbi = params.templateAbi || [];
    this.standard = params.standard;
  }

  getAddress(network: Network) {
    network = toMainnet(network);
    return (
      this.contracts.find((contract) => contract.network === network)
        ?.address || ""
    );
  }
}
